var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBookmarkFilled = function SvgBookmarkFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5626 22.4003C12.4765 22.4003 12.39 22.4003 12.3039 22.4003C12.1562 22.2627 11.9956 22.1406 11.8632 21.9844C10.1239 19.9332 8.38865 17.8766 6.65158 15.8221C6.60484 15.7668 6.55531 15.7136 6.49977 15.6512C6.44423 15.7136 6.3947 15.7662 6.34796 15.8216C4.59839 17.8919 2.84975 19.9634 1.09741 22.0304C0.977998 22.1712 0.83035 22.2775 0.695661 22.4003C0.609572 22.4003 0.523019 22.4003 0.43693 22.4003C0.0999766 22.2485 -0.000461257 21.9439 1.59073e-06 21.5374C0.00416722 14.6398 0.00324152 7.74232 0.00324152 0.844248C0.00324152 0.227361 0.195323 0 0.716027 0C4.57294 0 8.42984 0 12.2863 0C12.8047 0 12.9968 0.228457 12.9968 0.846988C12.9968 7.74451 12.9954 14.642 13 21.5401C13 21.9466 12.8982 22.2485 12.5626 22.4003Z",
    stroke: "black",
    strokeWidth: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bookmark_filled.352e8bd1ec68107f2d99a9deb6d78714.svg";